import { createSignal, createEffect } from "solid-js";

export type ThemeMode = "auto" | "dark" | "light";
const STORAGE_KEY = "vektor.theme";

function readInitial(): ThemeMode {
  if (typeof localStorage === "undefined") return "auto";
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "dark" || v === "light" || v === "auto") return v;
  } catch { /* ignore */ }
  return "auto";
}

function systemPrefersLight(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(prefers-color-scheme: light)").matches ?? false;
}

const [mode, setMode] = createSignal<ThemeMode>(readInitial());

function effective(): "dark" | "light" {
  const m = mode();
  if (m === "auto") return systemPrefersLight() ? "light" : "dark";
  return m;
}

createEffect(() => {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", effective());
  try { localStorage.setItem(STORAGE_KEY, mode()); } catch { /* ignore */ }
});

if (typeof window !== "undefined" && window.matchMedia) {
  const mq = window.matchMedia("(prefers-color-scheme: light)");
  mq.addEventListener?.("change", () => {
    if (mode() === "auto") {
      document.documentElement.setAttribute("data-theme", effective());
    }
  });
}

export function useTheme() {
  return {
    mode,
    effective,
    setMode,
  };
}
